const DEFAULT_HOURLY_DURATION = 1

window.Route = class {
  constructor (params) {
    this.positionFrom = params.positionFrom
    this.positionTo = params.positionTo
    this.withPrices = params.withPrices
    this.returnWay = params.returnWay
    this.dateTo = params.dateTo
    this.dateReturn = params.dateReturn
    this.hourlyDateEnd = params.hourlyDateEnd
    this.pax = params.pax
    this.countries = params.countries
    this.data = null
    this.hourly = params.hourly
    this.delivery = params.delivery
  }

  getInfo (callback) {
    let duration = DEFAULT_HOURLY_DURATION;
    if (this.hourlyDateEnd && this.dateTo) {
      duration = ((this.hourlyDateEnd.getTime() - this.dateTo.getTime()) / (60 * 60 * 1000)).toFixed(2);
    }
    $.ajax({
      url: '/api/route_info',
      dataType: 'json',
      data: {
        points: [this.positionFrom, this.positionTo],
        with_prices: this.withPrices,
        return_way: this.returnWay,
        date_to: this.dateTo,
        date_return: this.dateReturn,
        pax: this.pax,
        countries: this.countries,
        duration: this.hourly && parseFloat(duration) > 0 ? duration : null,
        delivery: this.delivery,
      },
      context: this,
      success (response, status, jqXHR) {
        if (!response || !response.data) {
          Raven.captureMessage('getInfo did not respond correctly', {
            extra: {
              request: jqXHR,
              status: status,
              response: response
            }
          })
          return
        }
        let info = response.data
        if (info.success) {
          this.decodeRoutePaths(info.routes[0])
          MapRoutes.routeInfo.distance = +info.distance
          MapRoutes.routeInfo.duration = +info.duration
          MapRoutes.changeMetrics()
        }
        callback(info)
      }
    })
  }

  decodeRoutePaths (route) {
    window.queue.afterMapsLoaded(() => {
      route.overview_path = this.decodePath(route.overview_polyline.points)
      route.legs[0].steps.forEach(step => {
        step.path = this.decodePath(step.polyline.points)
      })
    });
  }

  decodePath (points) {
    return google.maps.geometry.encoding.decodePath(points)
  }
}
